import { fromJS } from 'immutable';

const initialState = fromJS({
  menus: {},
});

export default (state = initialState) => state;
